import { __rest } from 'tslib';
import React from 'react';
import { s as styled } from './styled-112a8bd0.js';
import { C as Col } from './Col-338cdb74.js';
import { C as CustomLink } from './CustomLink-6694df28.js';
import { t as theme } from './theme-c93653c9.js';
import { S as SvgIcon } from './SvgIcon-1ee3e5bb.js';

const Wrapper = styled.div((props) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: ${props.hasDivider ? `1px solid ${props.color}` : ''};
`);
const Title = styled.div((props) => `
  color: ${props.color};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`);
const Decor = styled.div((props) => `
  position: absolute;
  left: 0;
  margin-top: 2px;
  width: 3px;
  height: 21px;
  background-color:  ${props.color};
`);
const ActionLink = styled.div((props) => `
  color: ${props.color} !important;
  --button-icon-color: ${props.color};
  text-decoration: none;
  float: right;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    ${props.hover === 'underline'
    ? 'text-decoration: underline'
    : `color: ${theme.brand.primary} !important`}
  }
`);
const StyledIcon = styled(SvgIcon) `
  position: relative;
  top: 2px;
`;
const ActionLinkTitle = styled.span `
  margin-right: 5px;
`;
const BlockHeader = (_a) => {
    var { title, actionLink, color = '#333', hasDivider = false, content } = _a, props = __rest(_a, ["title", "actionLink", "color", "hasDivider", "content"]);
    return (React.createElement(Wrapper, Object.assign({ hasDivider: hasDivider, color: color }, props),
        React.createElement(Col, null, title && (React.createElement(React.Fragment, null,
            React.createElement(Decor, { color: color }),
            React.createElement(Title, { color: color, className: "title" }, title)))),
        content && React.createElement(Col, { col: actionLink ? 9.8 : 10.95 }, content),
        actionLink && (React.createElement("div", null,
            React.createElement(CustomLink, { targetPath: actionLink.href },
                React.createElement(ActionLink, Object.assign({ color: actionLink.color || '#f1f0f1' }, (actionLink.regionName && {
                    'data-track-content': true,
                    'data-content-region-name': actionLink.regionName,
                    'data-content-name': actionLink.contentName,
                    'data-content-target': actionLink.target,
                }), { hover: actionLink.hover }),
                    React.createElement(ActionLinkTitle, null, actionLink.title),
                    !actionLink.hideIcon && (React.createElement(StyledIcon, { name: "chevron-forward", size: 13 }))))))));
};

export { BlockHeader as B };
